import { useMemo } from 'react';
import type { UseQueryOptions } from '@tanstack/react-query';
import {
  useBuscaApuracaoDetalhada,
  type BuscaApuracaoDetalhadaResponse,
  type FiltrosApuracaoDetalhada,
} from '@/services/ApuracaoDetalhada';
import type { FiltrosGestaoImpostos, TotaisIBSCBS } from '../types';

/**
 * IBS/CBS e Total de Vendas do período — não faz fetch próprio, só projeta
 * `useBuscaApuracaoDetalhada` (já testado e usado por `apuracao-detalhada`)
 * no formato que Gestão de Impostos precisa, evitando duplicar a chamada.
 */
export function useTotaisIBSCBS(
  filtros?: FiltrosGestaoImpostos,
  options?: Omit<UseQueryOptions<BuscaApuracaoDetalhadaResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const filtrosApuracaoDetalhada: FiltrosApuracaoDetalhada = {
    empresaId: filtros?.empresaId,
    dataInicio: filtros?.dataInicio,
    dataFim: filtros?.dataFim,
  };

  const query = useBuscaApuracaoDetalhada(filtrosApuracaoDetalhada, options);

  const data = useMemo<TotaisIBSCBS | undefined>(() => {
    const totais = query.data?.data?.totais;
    if (!totais) return undefined;
    return {
      totalVendas: totais.TotalValorOperacao,
      ibs: totais.TotalValorIBS,
      cbs: totais.TotalValorCBS,
    };
  }, [query.data]);

  return { ...query, data };
}
